<fr-table Id="log-details-table" [config]="tableConfig" [paginatorConfig]="paginatorConfig"
          [data]="data">
</fr-table>
